/**
 * Endless person list (clients / employees, table and matrix).
 * Prefetches the next Kaminari page via IntersectionObserver before the
 * sentinel reaches the viewport, so scrolling stays seamless.
 */

let observer = null;
let loading = false;
let observed_sentinel = null;
let current_request = null;
window.personListLazyGeneration = window.personListLazyGeneration || 0;

function sentinel_element() {
  return document.querySelector('#ajaxed_person_list .js-person-list-lazy-sentinel');
}

function preload_root_margin() {
  const preload_px = Math.max(1400, Math.round(window.innerHeight * 1.75));
  return `0px 0px ${preload_px}px 0px`;
}

function disconnect_observer() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
}

function abort_current_request() {
  if (current_request && current_request.abort) {
    current_request.abort();
  }
  current_request = null;
}

function load_next_person_list_page(sentinel) {
  if (!sentinel || loading) return;

  const next_page = sentinel.getAttribute('data-next-page');
  const url = sentinel.getAttribute('data-url');
  if (!next_page || !url) {
    disconnect_observer();
    return;
  }

  loading = true;
  sentinel.setAttribute('data-loading', 'true');
  disconnect_observer();

  const generation = window.personListLazyGeneration;
  current_request = $.ajax({
    url: url,
    method: 'GET',
    dataType: 'script',
    cache: false,
    data: { page: next_page, lazy: 1, generation: generation },
    complete: function () {
      if (generation !== window.personListLazyGeneration) return;
      loading = false;
      current_request = null;
      const next_sentinel = sentinel_element();
      if (!next_sentinel) return;
      next_sentinel.removeAttribute('data-loading');
      observe_sentinel(next_sentinel);
    }
  });
}

function observe_sentinel(sentinel) {
  disconnect_observer();
  if (!sentinel) return;

  if (typeof IntersectionObserver === 'undefined') {
    load_next_person_list_page(sentinel);
    return;
  }

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        load_next_person_list_page(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: preload_root_margin(),
    threshold: 0
  });

  observer.observe(sentinel);
}

export function initPersonListLazyLoading() {
  const sentinel = sentinel_element();
  if (!sentinel) {
    abort_current_request();
    disconnect_observer();
    observed_sentinel = null;
    loading = false;
    return;
  }

  if (observed_sentinel === sentinel && (observer || loading)) return;

  abort_current_request();
  window.personListLazyGeneration = (window.personListLazyGeneration || 0) + 1;
  observed_sentinel = sentinel;
  loading = false;
  observe_sentinel(sentinel);
}
